import React, { useEffect, useState } from "react";
import api from "../../../../api"; // adjust path

const Contact = () => {
  const [contactData, setContactData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const response = await api.get("/api/sitepages/alumni/contact");
        setContactData(response.data.contact_data || []);
      } catch (error) {
        console.error("Error fetching contact data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContact();
  }, []);

  if (loading || !contactData.length) return null;

  return (
    <section className="contact-details-alumni">
      <div className="container">
        <div className="row mb-5 mt-5">
          {contactData.map((item, index) => (
            <div
              key={index}
              className=" col-md-3  col-11 mx-auto mb-4"
            >
              <div
                className="card p-3 shadow wow fadeInUp"
                data-wow-delay={item.delay}
              >
                <img
                  src={`${process.env.REACT_APP_API_URL}/public/${item.image}`}
                  alt={item.title}
                  className="img-fluid"
                  width="80"
                />
                <h5 className="mt-3">{item.title}</h5>
                <p>
                  {item.link ? (
                    <a
                      href={item.link}
                      className="text-decoration-none text-dark"
                    >
                      {item.content}
                    </a>
                  ) : (
                    item.content
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;